import { FC } from 'react';

import { DualMode, ImageModeDesktop, ImageModeMobile } from './AdaptiveImage.styles';

export const AdaptiveImage: FC<{ src: string; alt: string; className?: string }> = ({ src, alt, className }) => {
    return (
        <DualMode className={className}>
            <ImageModeDesktop src={src} alt={alt} />
            <ImageModeMobile src={src} alt={alt} />
        </DualMode>
    );
};
